module.exports = __webpack_public_path__ + "media/images/app/banner-ddf70f03b85e231717428c40a445e6aa.svg";